import { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { IoTicket } from "react-icons/io5";
import { FaRegCheckCircle, FaCheck } from "react-icons/fa";

export default function Form() {

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    const [selectedDocument, setSelectedDocument] = useState(null);

    const handleDocumentToggle = (field) => (event) => {
        const isChecked = event.target.checked;

        if (!isChecked) {
            setSelectedDocument(null);
            setValue(field, false);
            setValue("promocode", "");
            return;
        }

        if (format === "vip") {
            setFormat("standard");
        }

        setSelectedDocument(field);

        if (field === "ubd") {
            setValue("ubd", true);
            setValue("vpo", false);
            setValue("promocode", "ubd");
            return;
        }

        setValue("ubd", false);
        setValue("vpo", true);
        setValue("promocode", "wpo");
    };

    // Функція для отримання значення з cookie
    const getCookie = (cookieName) => {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArr = decodedCookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    };

    // Ціни для кожного формату
    const prices = {
        Standard: {
            current: 1000,
            original: 2500,
        },
        Vip: {
            current: 3000,
            original: 5000,
        },
    };

    const currentPath = window.location.pathname;
    const isEn = currentPath.startsWith("/en");
    const [preloader, preloaderFormStyle] = useState("hidden");
    const [promoAlert, setPromoAlertData] = useState("");
    const [promoAlertStyle, setPromoAlerStyle] = useState("");
    const [format, setFormat] = useState("standard");
    const [showUbd, setShowUbd] = useState(false);

    const errorStyle = "absolute -top-2 right-0 text-red-800 z-20 text-[13px] px-[4px] leading-none flex items-center bg-white";
    const successStyle = "absolute top-0 right-0 text-[#003366] z-20 text-sm h-full p-[4px] leading-none rounded-full flex items-center";

    const domain = window.location.protocol + "//" + window.location.host;

  
    const inputStyle = "w-full h-[47px] bg-white px-[15px] text-[12px] text-black uppercase tracking-[0.15em] placeholder:text-black/70 placeholder:uppercase placeholder:tracking-[0.15em] focus:outline-none";
    
    const clearDataPromo = async (data) => {
        var promocodeData = {
            promocode: data,
            site_name: domain,
            action: "checkpromo",
            package: format,
            ticket_type: format
        };

        try {
            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-forms-handler-dev/handler.php?event_id=4393",
                promocodeData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 201 || response.status === 200) {
                if (response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(<FaCheck />);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const onSubmit = async (data) => {
        try {
            preloaderFormStyle("flex");
            console.log(data);
            // Надіслати подію в GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_send',
                formType: 'Contact',
            });

            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-forms-handler-dev/handler.php?event_id=4393",
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.data.check !== false) {
                window.location.href = '/congratulations';
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            preloaderFormStyle("hidden");
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if (value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    // URL params
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";
    const utm_content = searchParams.get("utm_content") || "";

    // Translated texts
    const priceNote = isEn ? "* Price before tax" : "* Ціна до оподаткування";
    const emailError = isEn ? "enter email" : "вкажіть email";
    const phoneError = isEn ? "enter phone" : "вкажіть телефон";
    const submitText = isEn ? "Submit" : "Надіслати";
    const waitText = isEn ? "Please wait..." : "Зачекайте...";
    const price = isEn ? "uah" : "грн";
    const selectedPrice = format === "vip" ? prices.Vip : prices.Standard;

    useEffect(() => {
        setValue("package", format);
        setValue("ticket_type", format);
        setValue("price", selectedPrice.current);
        setValue("user_agent", navigator.userAgent);
        setValue("ubd", false);
        setValue("vpo", false);

        const fbc = getCookie("_fbc");
        const fbp = getCookie("_fbp");
        if (fbc) setValue("fbc", fbc);
        if (fbp) setValue("fbp", fbp);

        const fetchIpAddress = async () => {
            const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
            if (isLocalhost || process.env.NODE_ENV === "development") {
                setValue("user_ip", "");
                return;
            }

            try {
                const response = await axios.get("https://api.ipify.org?format=json");
                setValue("user_ip", response.data.ip);
            } catch (error) {
                console.error("Не вдалося отримати IP-адресу: ", error);
                setValue("user_ip", "");
            }
        };

        fetchIpAddress();
    }, [format, selectedPrice, setValue]);

    return (
        <div id="frstscrn" className="relative z-20">

            <div>

                {/* <div className="grid grid-cols-2 gap-2 mb-2 lg:gap-5">
                    <button  type="button"
                        onClick={() => {
                            setFormat("standard");
                            setSelectedDocument(null);
                            setValue("ubd", false);
                            setValue("vpo", false);
                            setValue("promocode", "");
                            clearDataPromo("");
                            setShowUbd("show");
                        }}
                        className={`relative min-h-[62px] px-[12px] py-[8px] text-left uppercase transition
                                xl:min-h-[80px] lg:px-[15px] ${
                            format === "standard"
                                ? "bg-[#11118E] text-white"
                                : "bg-gradient-to-br from-[#F6D8FF] via-[#D4E5FF] to-[#84BFFF] text-[#17134C]"
                        }`}
                    >
                        <div className="text-[11px] lg:text-sm xl:text-base uppercase font-semibold tracking-[0.15em] mb-[10px]">Standard</div>

                        <div className="flex items-end justify-between gap-[6px]">
                            <span className="text-[20px] lg:text-[22px] xl:text-[30px] font-bold leading-none flex items-end gap-1">
                               {prices.Standard.current}
                                <span className="text-[6px] text-[10px] leading-none">{price}*</span>
                            </span>
                            <span className="text-[20px] lg:text-[22px] xl:text-[30px] leading-none relative">
                                {prices.Standard.original}
                                <span className="block absolute -left-[5px] top-1/2 -translate-y-1/2
                                            w-[100%] h-[3px] bg-[#e53226] opacity-80 -rotate-6"></span>
                                <span className="text-[6px] text-[10px]">{price}*</span>
                            </span>
                        </div>

                        {format === "standard" && (
                            <span className="absolute right-[8px] top-[-7px] flex size-[22px] items-center justify-center rounded-full bg-white text-[#11118E]">
                                <FaCheck className="text-[11px]" />
                            </span>
                        )}
                    </button>
                    <button  type="button"
                        onClick={() => {
                            setFormat("vip");
                            setSelectedDocument(null);
                            setValue("ubd", false);
                            setValue("vpo", false);
                            setValue("promocode", "");
                            clearDataPromo("");
                            setShowUbd("show");
                        }}
                        className={`relative min-h-[52px] px-[10px] py-[8px] lg:px-[15px] text-left uppercase transition xl:min-h-[80px] ${
                            format === "vip"
                                ? "bg-[#11118E] text-white"
                                : "bg-gradient-to-br from-[#F3D9FF] via-[#D9E4FF] to-[#75B8FF] text-[#17134C]"
                        }`}
                    >
                        <div className="text-[11px] lg:text-sm xl:text-base uppercase font-semibold tracking-[0.15em] mb-[10px]">Vip</div>

                        <div className="flex items-end justify-between gap-[6px]">
                            <span className="text-[20px] lg:text-[22px] xl:text-[30px] font-bold leading-none flex items-end gap-1">
                                {prices.Vip.current}
                                <span className="text-[6px] lg:text-[10px] leading-none">грн*</span>
                            </span>
                            <span className="text-[17px] lg:text-[22px] xl:text-[30px] font-bold  leading-none relative">
                               {prices.Vip.original}
                                <span className="block absolute -left-[5px] top-1/2 -translate-y-1/2
                                    w-[100%] h-[3px] bg-[#e53226] opacity-80 -rotate-6"></span>
                                <span className="text-[6px] lg:text-[10px] ">грн*</span>
                            </span>
                        </div>

                        {format === "vip" && (
                            <span className="absolute right-[8px] top-[-7px] flex size-[22px] items-center justify-center rounded-full bg-white text-[#11118E]">
                                <FaCheck className="text-[11px]" />
                            </span>
                        )}
                    </button>
                </div> */}
                {/* <p className="text-sm text-black font-light mb-4">{priceNote}</p> */}

                <h4 className="font-bold uppercase mb-7 lg:text-2xl max-w-[540px] mr-10">Попередня реєстрація на GET Business Festival</h4>


                <form onSubmit={handleSubmit(onSubmit)} className="relative mb-4">

                    <input name="site_name" {...register("site_name")} type="hidden" value={domain} />
                    <input name="price" {...register("price")} type="hidden" />
                    <input name="package" {...register("package")} type="hidden" />
                    <input name="ticket_type" {...register("ticket_type")} type="hidden" />
                    <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source} />
                    <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium} />
                    <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign} />
                    <input name="user_agent" {...register("user_agent")} type="hidden" />
                    <input name="user_ip" {...register("user_ip")} type="hidden" />
                    <input name="fbc" type="hidden" {...register("fbc")} />
                    <input name="fbp" type="hidden" {...register("fbp")} />


                    <div className="grid gap-[10px] sm:grid-cols-2 mb-3">
                        {/*<div className="relative">
                            <input type="text" name="name" {...register("name", { required: true })} placeholder="Прізвище та ім’я" className={inputStyle}/>
                            {errors.name && <div className={errorStyle}>вкажіть ім’я</div>}
                        </div>*/}
                        <div className="relative">
                            <input type="email" name="email" {...register("email", { required: true })} placeholder={isEn ? "Email" : "Пошта"} className={inputStyle}/>
                            {errors.email && <div className={errorStyle}>{emailError}</div>}
                        </div>
                        <div className="relative">
                            <input type="text" name="phone" {...register("phone", { required: true, pattern: /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/, })}
                                maxLength="17" placeholder={isEn ? "Phone (099) 999-99-99" : "Тел. (099) 999-99-99"}
                                onChange={(event) => {
                                    const { value } = event.target;
                                    event.target.value = normalizeTel(value);
                                }}
                                className={inputStyle + " " + (errors.phone ? "form-control text-amber-700" : "form-control")}
                            />
                            {errors.phone && (
                                <div className={errorStyle}>{phoneError}</div>
                            )}
                        </div>

                        {/* {selectedDocument === null ? (
                            <div className="relative">
                                <input type="text" name="promocode" {...register("promocode")} placeholder={isEn ? "Promo code" : "Промокод"}
                                    onBlur={(event) => {
                                        const { value } = event.target;
                                        clearDataPromo(value);
                                    }}
                                    className={inputStyle}
                                />
                            </div>
                        ) : (
                            <input type="hidden" name="promocode" {...register("promocode")} />
                        )} */}

                        <input type="submit" name="submit" value={submitText}
                        className="hidden md:block cursor-pointer text-center py-[9px] w-full text-block bg-[#ffd97c] uppercase px-4 z-20 relative
                        text-xl font-bold" />
                    </div>

                   
                    {/* <div className="grid sm:grid-cols-2 gap-2 mb-2">
                        <label className={"group text-[10px] font-medium uppercase tracking-[0.15em] relative flex items-center gap-3" + (showUbd)}>
                            <input
                                type="checkbox"
                                name="ubd"
                                {...register("ubd")}
                                checked={selectedDocument === "ubd"}
                                disabled={selectedDocument !== null && selectedDocument !== "ubd"}
                                onChange={handleDocumentToggle("ubd")}
                                className="mr-2 appearance-none relative block w-3 h-3 shrink-0 border border-black cursor-pointer checked:border-black after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-1 after:-translate-x-1/2 after:-translate-y-1/2 after:rotate-45 after:border-b-2 after:border-r-2 after:border-black after:opacity-0 checked:after:opacity-100"
                            />
                            Маю посвідчення УБД <span className="text-red-600">*</span>
                        </label>
                        <label className={"group text-[10px] font-medium uppercase tracking-[0.15em] relative flex items-center" + (showUbd)}>
                            <input
                                type="checkbox"
                                name="vpo"
                                {...register("vpo")}
                                checked={selectedDocument === "vpo"}
                                disabled={selectedDocument !== null && selectedDocument !== "vpo"}
                                onChange={handleDocumentToggle("vpo")}
                                className="mr-2 appearance-none relative block w-3 h-3 shrink-0 border border-black cursor-pointer checked:border-black after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-1 after:-translate-x-1/2 after:-translate-y-1/2 after:rotate-45 after:border-b-2 after:border-r-2 after:border-black after:opacity-0 checked:after:opacity-100"
                            />
                            Маю посвідчення ВПО <span className="text-red-600">*</span>
                        </label>
                    </div>
                    <p className="text-[9px] text-black mb-3 max-w-[540px]">*Участь для УБД та ВПО безкоштовна (за умови наявності посвідчення) </p>


                    <a href="https://forms.gle/sUHSUFa6anM3Cupp6" target="_blank"
                        className="block text-[11px] font-medium uppercase tracking-[0.15em] mb-3 underline">
                        Корпоративним клієнтам</a>
                         
                    <input type="submit" name="submit" value={submitText}
                        className="block md:hidden cursor-pointer text-center py-[9px] w-full text-block bg-[#ffd97c] uppercase px-4 z-20 relative
                        text-xl font-bold" /> */}
                   

                    <div className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#003366] " + preloader}>
                        <div className="flex text-2xl justify-center items-center">
                            <FaRegCheckCircle className="mr-3" />
                            <span>{waitText}</span>
                        </div>
                    </div>

                </form>

            </div>


        </div>
    );
}
